export function formatDiff(diffSec: number) {
    const days = Math.floor(diffSec / 86400);
    diffSec %= 86400;

    const hours = Math.floor(diffSec / 3600);
    diffSec %= 3600;

    const minutes = Math.floor(diffSec / 60);
    const seconds = diffSec % 60;

    return { days, hours, minutes, seconds };
}

export function itemHridToItemName(itemHrid: string) {
    return itemHrid.slice(7)
}

export function effiencyNumberOfActions(efficiency: number) {
    if (efficiency <= 0) return 1;

    // Guaranteed Actions = 1 (base) + floor(Efficiency / 100)
    // Chance for +1 More = Efficiency mod 100

    const guaranteed = 1 + Math.floor(efficiency/100)
    const chance = (efficiency % 100)/100

    return guaranteed + chance
}

export function timeUntilDropPercentile(
  dropChance: number,
  percentile: number, // z.B. 0.5 für 50%
  actionsPerSecond: number
): number {
  // Löse: 1 - (1 - p)^N = percentile  →  N = log(1 - percentile) / log(1 - p)
  const actions = Math.log(1 - percentile) / Math.log(1 - dropChance);
  return actions / actionsPerSecond; // Sekunden
}